import Keycloak from 'keycloak-js';
import { KeycloakManager } from '@shared/services/keycloak-manager/keycloak-manager.service';

export const getKeycloakInstance = (): Keycloak => KeycloakManager.getInstance();
